module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new":"New Flow","restore":"@:labels.restore","title":"@:labels.flows"},"fr":{"new":"Nouveau flux","restore":"@:labels.restore","title":"@:labels.flows"}}')
  delete Component.options._Ctor
}
